export default {"src":"/_next/static/image/src/onboarding/BenefitsOverview/manage-order.e3d1e9953c20e14323ec303c2a92901e.svg","height":62,"width":60};